import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-header" }, "Aceita reagendar esta sessão?", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph mb-0" }, " Paciente solicitou um novo horário para esta sessão, você aceita alterar a data da sessão? ", -1)
const _hoisted_5 = { class: "d-flex align-items-center py-4 border-bottom justify-content-between" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph mb-0" }, "Novo dia", -1)
const _hoisted_7 = { class: "text-subtitle mb-0" }
const _hoisted_8 = { class: "d-flex align-items-center py-4 justify-content-between" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph mb-0" }, "Novo horário", -1)
const _hoisted_10 = { class: "text-subtitle mb-0" }
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = { class: "d-flex align-items-center mb-3" }
const _hoisted_13 = { class: "text-subtitle mb-0 ms-2" }
const _hoisted_14 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_ctx.request?.pendingByMe)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.request?.formattedDate), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.request?.formattedTime), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_Button, {
              label: "Rejeitar",
              outline: "",
              loading: _ctx.rejectingReschedule,
              fullWidth: "",
              class: "me-2",
              onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleRescheduleRequest('rejected')))
            }, null, 8, ["loading"]),
            _createVNode(_component_Button, {
              label: "Aceitar",
              loading: _ctx.acceptingReschedule,
              fullWidth: "",
              class: "ms-2",
              onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleRescheduleRequest('acecpted')))
            }, null, 8, ["loading"])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["alert", [_ctx.request?.bgColor, _ctx.request?.color]])
      }, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("i", {
            class: _normalizeClass(_ctx.request?.icon)
          }, null, 2),
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.request?.title), 1)
        ]),
        _createElementVNode("div", {
          innerHTML: _ctx.request?.description
        }, null, 8, _hoisted_14)
      ], 2))
}